// extracted by mini-css-extract-plugin
module.exports = {"container":"InfoBanner_container__2M5pB","icon":"InfoBanner_icon__3nenk","msg":"InfoBanner_msg__2dHFI","invalid":"InfoBanner_invalid__2xGXO"};